async function verificandoApp(local) {

    const tipoSoft = localStorage.getItem("tipoSoft");

    let teste;

    if ((tipoSoft || '').trim() === (local || '').trim()) {
        teste = true;
    } else {
        teste = false;

        localStorage.setItem("logado", "N");
        localStorage.setItem("codUsu", 0);
        localStorage.setItem("loginSati", '');
        localStorage.setItem("senhaSati", '')
        localStorage.setItem("nomUsuSat", '');
        localStorage.setItem("usrEmlSat", '');
        localStorage.setItem("tipoSoft", '');
    }

    return (teste);
}

export default verificandoApp;
